import * as React from "react";
import styled, { css } from "react-emotion";
import { small } from "../theme/typefaces";
import { greyColors, primaryColors, secondaryColors } from "../theme/colors";
import { spacing } from "../theme/layout";
import { Icon } from "../theme/icons/index";
import { secondaryButtonStyle } from "./Controls";
const AlertContainer = styled("div") `
  display: flex;
  flex-direction: column;
  align-items: center;
  ${spacing.pa1};
  margin: auto; /* Centering in flex containers */
`;
const IconContainer = styled("div") `
  & svg {
    font-size: 2.6em;
  }
`;
const TextContainer = styled("p") `
  ${spacing.mt2};
  ${spacing.mb0};
  ${small};
  text-align: center;
  max-width: 300px;
`;
const Button = styled("button") `
  ${secondaryButtonStyle};
  ${small};
  ${spacing.ph1};
  ${spacing.mt2};
  color: currentColor;
  border-color: currentColor;
  justify-content: center;
  background: transparent;
  line-height: 28px;
  width: auto;
  &:hover {
    color: currentColor;
    background-color: currentColor;
    border-color: currentColor;
    & span {
      color: ${primaryColors.white};
    }
  }
`;
export const AlertButton = ({ text, ...alertButtonProps }) => (<Button {...alertButtonProps}>
    <span>{text}</span>
  </Button>);
export const PrimaryAlert = ({ text, icon = "Info", color = greyColors["500"], action }) => (<AlertContainer style={{
    color
}}>
    <IconContainer>
      <Icon name={icon}/>
    </IconContainer>
    <TextContainer>{text}</TextContainer>
    {action && <AlertButton {...action}/>}
  </AlertContainer>);
export const InfoAlert = ({ text, action }) => (<AlertContainer style={{
    color: primaryColors.zuerichBlue
}}>
    <IconContainer>
      <Icon name={"Info"}/>
    </IconContainer>
    <TextContainer>{text}</TextContainer>
    {action && <AlertButton {...action}/>}
  </AlertContainer>);
export const SuccessAlert = ({ text, action }) => (<AlertContainer style={{
    color: secondaryColors.green
}}>
    <IconContainer>
      <Icon name={"Check"}/>
    </IconContainer>
    <TextContainer>{text}</TextContainer>
    {action && <AlertButton {...action}/>}
  </AlertContainer>);
export const ErrorAlert = ({ text, action }) => (<AlertContainer style={{
    color: secondaryColors.red
}}>
    <IconContainer>
      <Icon name={"Cross"}/>
    </IconContainer>
    <TextContainer>{text}</TextContainer>
    {action && <AlertButton {...action}/>}
  </AlertContainer>);
const TextContainerInteg = styled("p") `
  ${spacing.mt2};
  ${spacing.mb0};
  ${small};
  text-align: center;
  max-width: 100%;
`;
const alertShown = css `
  opacity: 1;
  transition: all 250ms linear;
`;
const alertHidden = css `
  opacity: 0;
  visibility: hidden;
  height: 0;
  padding: 0;
  transition: all 250ms linear;
`;
const alertStyle = {
    color: primaryColors.zuerichBlue
};
const linkStyle = {
    color: primaryColors.zuerichBlue
};
export const InfoAlertInteg = ({ text, action, state }) => (<AlertContainer className={` ${state ? `${alertHidden}` : `${alertShown}`} `} style={alertStyle}>
    <IconContainer>
      <Icon name={"Info"}/>
    </IconContainer>
    <TextContainerInteg>
      {text} <a style={linkStyle} href='https://www.stadt-zuerich.ch/statistik'>www.stadt-zuerich.ch/statistik.</a>
    </TextContainerInteg>
    {action && <AlertButton {...action}/>}
  </AlertContainer>);



// WEBPACK FOOTER //
// ./src/components/Alerts.tsx